<template>
    <v-tab-item :value="LOCATION.value">
        <section class="sub-section">
            <v-container>
                <div class="radius mb-20 mb-lg-40" style="height: 450px;">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.354085087934!2d126.88393671564631!3d37.47596983706655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61e13c9bce95%3A0x236b85f21ee492f2!2z7ISc7Jq47Yq567OE7IucIOq4iOyynOq1rCDrsprqvYProZwgMjM0!5e0!3m2!1sko!2skr!4v1663312506025!5m2!1sko!2skr" width="100%" height="452" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>

                <div style="border-top: 2px solid var(--v-primary-base)">             

                    <div class="company-info d-flex py-16 py-md-30 border-bottom border-color-light">
                        <p class="company-info-tit page-text-sm font-weight-bold pl-16 pl-lg-40">
                            주소
                        </p>
                        <p class="page-text-sm color-grey-49 pl-16 pl-lg-40">
                            서울특별시 금천구 벚꽃로 234 에이스하이앤드타워 6차, 1402호
                        </p>
                    </div>

                    <v-row no-gutters>
                        <v-col cols="12" lg="4">
                            <div class="company-info d-flex py-16 py-md-30 border-bottom border-color-light">
                                <p class="company-info-tit page-text-sm font-weight-bold pl-16 pl-lg-40">
                                    전화번호
                                </p>
                                <p class="page-text-sm color-grey-49 pl-16 pl-lg-40">
                                    070-4640-3030
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <div class="company-info d-flex py-16 py-md-30 border-bottom border-color-light">
                                <p class="company-info-tit page-text-sm font-weight-bold pl-16 pl-lg-40">
                                    이메일
                                </p>
                                <p class="page-text-sm color-grey-49 pl-16 pl-lg-40">
                                    sales@f1security.co.kr
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <div class="company-info d-flex py-16 py-md-30 border-bottom border-color-light">
                                <p class="company-info-tit page-text-sm font-weight-bold pl-16 pl-lg-40">
                                    팩스번호
                                </p>
                                <p class="page-text-sm color-grey-49 pl-16 pl-lg-40">
                                    02-6944-8448
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>   
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { ABOUT_US_TABS } from "@/assets/variables";
const { LOCATION } = ABOUT_US_TABS;
export default {
    data() {
        return {
            LOCATION,
        };
    },
};
</script>

<style scoped>
.company-info-tit{
    min-width: 64px;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .company-info-tit{
        min-width: 101px;
    }
}
@media (min-width:1200px){
}

</style>
